//根据所在环境配置全局环境变量
//'https://uc-test.pkpm.cn/login'
//'https://uc-test-rev.pkpm.cn/login'
// 'http://localhost:8080/login'
// 'https://uc.pkpm.cn/login'

//本地环境，测试环境
// let Env_currentenv='deveploment'//当前环境为测试和开发环境
// let Env_wxloginurl='https://uc-test.pkpm.cn/login'//测试环境微信登录
// let Env_H5wxloginurl='https://uc-test.pkpm.cn/NVH5Login'//测试环境移动端微信登录
// let Env_cloudspace='e558ab89-f00d-4f93-b632-763b0ffd1941'//测试环境开通云盘会员跳转产品id的链接
// let Env_H5Wxappid='wxc092004b1e5412a0'//公众号是北京构力科技有限公司
// let ENV_H5WxappDomain='https://uc.pkpm.cn/H5wechatHome'//云账号移动端空白中转页面,移动端微信登录--公众号-绑定的域名，uc-test，uc.pkpm.cn代码的回调域名必须和绑定的域名一致
//正式环境
let Env_currentenv='production' //当前环境为正式环境
let Env_wxloginurl='https://uc.pkpm.cn/login'//正式环境微信登录
let Env_H5wxloginurl='https://uc.pkpm.cn/NVH5Login'//测试环境移动端微信登录
let Env_cloudspace='6ec0f2b5-520f-47d9-bbc4-bd21b6928d53'//正式环境开通云盘会员跳转产品id的链接
let Env_H5Wxappid='wxc092004b1e5412a0'//公众号是北京构力科技有限公司
let ENV_H5WxappDomain='https://uc.pkpm.cn/H5wechatHome'//云账号移动端空白中转页面,移动端微信登录--公众号-绑定的域名，uc-test，代码的回调域名必须和绑定的域名一致


//绿箭内网
//let Env_currentenv='deveploment'//当前环境为测试和开发环境
//let Env_wxloginurl='https://uc-test.pkpm.cn/login'//测试环境微信登录
//let Env_cloudspace='e558ab89-f00d-4f93-b632-763b0ffd1941'//测试环境开通云盘会员跳转产品id的链接
//let Env_H5Wxappid='wxc092004b1e5412a0'//公众号是北京构力科技有限公司
//let ENV_H5WxappDomain='https://uc-test.pkpm.cn/H5wechatHome'//云账号移动端空白中转页面,移动端微信登录--公众号-绑定的域名，uc-test，代码的回调域名必须和绑定的域名一致


export {Env_wxloginurl,
    Env_currentenv,
    Env_cloudspace,
    Env_H5Wxappid,
    ENV_H5WxappDomain,
    Env_H5wxloginurl
}



//////////////////
// WEBPACK FOOTER
// ./config/myglobalenvConfig.js
// module id = GLb5
// module chunks = 113